import { memo, Children } from 'react';

import styles from './DotList.scss';

interface DotListProps {
  children: React.ReactNode;
}

const DotList = ({ children }: DotListProps) => {
  return (
    <ul className={styles.ul}>
      {Children.map(children, (item, index) => (
        <li key={index} className={styles.li}>
          {item}
        </li>
      ))}
    </ul>
  );
};

export default memo(DotList);
